export default {
    profile_update_password_title: "Actualizar contraseña"
}